import React from "react";
import { Link } from "react-router-dom";

import Fulllogo from '../../image/logo-nbc-full.svg'

const ForgotPassword = ({ history }) => {
  const onSubmit = (e) => {
    e.preventDefault();
    history.push("/login");
  };
  return (
    <div className="vh-100 login-main-page">
      <div className="row m-0 justify-content-center h-100 align-items-center">
        <div className="login-wrapper">
          <div className="login-aside-right">
            <div className="col-xl-12">
              <div className="authincation-content">
                <div className="row no-gutters">
                  <div className="col-xl-12">
                    <div className="auth-form-1">
                      <div className="mb-5">
                        <Link to="/dashboard" className="login-logo1 logo-center">
                          <img src={Fulllogo} alt="" className='mb-4 logo' /> 
                        </Link>
                        <h4 className="text-white mb-1 text-center login-text">Forget Password</h4>
                      </div>
                    </div>
                    <form onSubmit={(e) => onSubmit(e)}>
                      <div className="form-group">
                        <label className="mb-2 ">
                          <span className="text-white">Email ID</span>
                        </label>
                        <input type="email" className="form-control text-black" placeholder='Please Enter your Email' />
                      </div>
                      <div className="text-center mt-4">
                        <button type="submit" value="SUBMIT" className="btn btn-login-hover bg-white text-primary btn-block" > Forget Password </button>
                      </div>
                    </form>
                    <div className="new-account mt-5">
                      <p className="text-white text-center">Back to <Link className="text-white color-bg-link" to="./login">Sign in</Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
